<template>
<!-- Modal Map -->
<b-modal  ok-only centered size="lg" class="modal fade" id="ModalMap" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" @shown="modalShown">
  <div class="modal-dialog modal-lg">
    
      	<div class="map">	
		  	<l-map 
		  	:center="center"
		  	:zoom="zoom"
		  	class="map"
		  	ref="myMap"
		  	@update:zoom="zoomUpdated"
		  	@update:center="centerUpdated">
		  		<l-tile-layer
		  		:url="url"
		  		>
		  		</l-tile-layer>
		  		<l-marker :lat-lng="markerLatLng" ></l-marker>
		  	</l-map ref="myMap">
      	</div>
      	<div class="map-letter">
		  	<p class="center">
		  		Téléphone du Cabinet
		  		<h1 class="center"><span class="prix">06 63 39 08 08</span></h1>
		  		<hr />
	  		</p>
	  		<p class="center">
		  		Adresse du Cabinet
		  		<h1 class="center" style="line-height: 0.5;"><span class="adresse">101 route de Chambord</span> <br><span class="adresse2"> 41350, Huisseau-sur-cosson</span></h1>
		  		<hr/>
	  		</p>
	  		<p class="description" style="">
		  		Prise de contact et rendez vous par mail ou téléphone.
	  		</p>
	  	</div>
    
  </div>
  
</b-modal>
<!-- /.Modal Map -->
</template>

<script>
import { LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
export default {
components: {
   LMap,
   LTileLayer,
   LMarker
 },
 data () {
   return {
     url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
     center: [47.591715, 1.432974],
     markerLatLng: [47.591715, 1.452974],
     zoom: 12,
     zoomControl: false
   }
 },
 methods: {
   zoomUpdated (zoom) {
     this.zoom = zoom;
   },
   centerUpdated (center) {
     this.center = center;
   },
   modalShown() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.myMap.mapObject.invalidateSize(); 
      }, 100);
	  }
 }
}
</script>

<style scoped>

.description{
	font-size:12px;
	letter-spacing: 0px;
	font-variant-caps: normal;
	text-align: center;
}
.close{
	color: rgb(29,41,164,0.75)!important;
}
.close:hover{
	color: rgb(29,41,164,1)!important;
}
</style>
